<template>
  <div fluid fill-height>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <v-container style="min-width: 100% !important">
      <Tags />
    </v-container>
  </div>
</template>
<script>
import Tags from "../../components/Definiciones/Etiquetas/Tags.vue";
import LandingToolbar from "@/components/LandingToolbar/LandingToolbar.vue";

export default {
  components: { LandingToolbar, Tags },
};
</script>
